import { render, staticRenderFns } from "./CostBlock.vue?vue&type=template&id=1c06f7d4&"
import script from "./CostBlock.vue?vue&type=script&lang=js&"
export * from "./CostBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports